import Icon from '../components/Icon.vue'

Icon.register({
  'money-bill-wave': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M621.2 54.5c11.6 4.9 18.8 16.8 18.8 29.5v317.3c0 18.5-15 31.8-32.3 31.8-3.4 0-6.9-0.5-10.3-1.6-30.9-9.8-61.8-13.7-92.7-13.7-123.2 0-246.3 62.3-369.5 62.3-38.8 0-77.6-6.2-116.4-22.5-11.6-4.9-18.8-16.8-18.8-29.5v-317.3c0-18.5 15-31.8 32.3-31.8 3.4 0 6.9 0.5 10.3 1.6 30.9 9.8 61.8 13.7 92.7 13.7 123.2 0 246.3-62.3 369.5-62.3 38.8 0 77.6 6.2 116.4 22.5zM48 132.2v60.5c31 0 56.8-22.2 62.7-51.5-21.6-1.4-42.6-3.9-62.7-8.9zM48 417.2c20.1 7.3 41.2 11.8 63.7 13.6-1.5-34.1-29.3-61.4-63.7-61.4v47.8zM320 352c44.2 0 80-43 80-96 0-53-35.8-96-80-96s-80 43-80 96c0 53 35.8 96 80 96zM592 379.8v-57.7c-26.8 3.4-48.5 23.2-54.3 49.3 18.6 1.6 36.8 4 54.3 8.4zM592 143.7v-48.9c-17.7-6.4-36.3-10.5-55.8-12.7 0.9 31.8 24.9 57.6 55.8 61.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill-wave.js
// module id = 1577
// module chunks = 0